import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@sendgrid/style-guide-grid';
import { Radio } from '@sendgrid/ui-components/radio';
import withProfileInputs from '../containers/withProfileInputs';
import PROFILE from '../constants/profile';

export const EmailVolumeForm = props => (
  <section className={Grid.row} data-role="email-volume-container">
    <p className={`form-prompt ${Grid['col-12']}`} data-role="email-volume-prompt">
      How many emails do you send per month?
      {' '}
      <span className="required-dot">&bull;</span>
    </p>
    <div className={Grid['col-6']}>
      <Radio
        checked={props.profileInputs.emailVolume === PROFILE.LV_EMAIL}
        name="emailVolumeRadios"
        id="radio-volume-lv"
        label={PROFILE.LV_EMAIL}
        value={PROFILE.LV_EMAIL}
        data-role="radio-volume-lv"
        onChange={props.setEmailVolume}
      />
    </div>
    <div className={Grid['col-6']}>
      <Radio
        checked={props.profileInputs.emailVolume === PROFILE.MLV_EMAIL}
        name="emailVolumeRadios"
        id="radio-volume-mlv"
        label={PROFILE.MLV_EMAIL}
        value={PROFILE.MLV_EMAIL}
        data-role="radio-volume-mlv"
        onChange={props.setEmailVolume}
      />
    </div>
    <div className={Grid['col-6']}>
      <Radio
        checked={props.profileInputs.emailVolume === PROFILE.MV_EMAIL}
        name="emailVolumeRadios"
        id="radio-volume-mv"
        label={PROFILE.MV_EMAIL}
        value={PROFILE.MV_EMAIL}
        data-role="radio-volume-mv"
        onChange={props.setEmailVolume}
      />
    </div>
    <div className={Grid['col-6']}>
      <Radio
        checked={props.profileInputs.emailVolume === PROFILE.MHV_EMAIL}
        name="emailVolumeRadios"
        id="radio-volume-mhv"
        label={PROFILE.MHV_EMAIL}
        value={PROFILE.MHV_EMAIL}
        data-role="radio-volume-mhv"
        onChange={props.setEmailVolume}
      />
    </div>
    <div className={Grid['col-6']}>
      <Radio
        checked={props.profileInputs.emailVolume === PROFILE.HLV_EMAIL}
        name="emailVolumeRadios"
        id="radio-volume-hlv"
        label={PROFILE.HLV_EMAIL}
        value={PROFILE.HLV_EMAIL}
        data-role="radio-volume-hlv"
        onChange={props.setEmailVolume}
      />
    </div>
    <div className={Grid['col-6']}>
      <Radio
        checked={props.profileInputs.emailVolume === PROFILE.HMV_EMAIL}
        name="emailVolumeRadios"
        id="radio-volume-hmv"
        label={PROFILE.HMV_EMAIL}
        value={PROFILE.HMV_EMAIL}
        data-role="radio-volume-hmv"
        onChange={props.setEmailVolume}
      />
      <Radio
        checked={props.profileInputs.emailVolume === PROFILE.HV_EMAIL}
        name="emailVolumeRadios"
        id="radio-volume-hv"
        label={PROFILE.HV_EMAIL}
        value={PROFILE.HV_EMAIL}
        data-role="radio-volume-hv"
        onChange={props.setEmailVolume}
      />
    </div>
  </section>
);

EmailVolumeForm.propTypes = {
  setEmailVolume: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    emailVolume: PropTypes.string.isRequired,
  }).isRequired,
};

export default withProfileInputs(EmailVolumeForm);
